import React, { useCallback, useEffect, useState } from 'react';
import { Container } from './styles';

import { useForm } from 'react-hook-form';
import api from '~/services/api';
import { InputSelect } from '../NovosInputs';

interface Options {
  label: string | undefined;
  value: number | string | undefined;
}

interface IOperadores {
  cod_operador: number;
  des_operador: string;
  cod_loja: number;
}

interface OperadoresProps {
  value: Options | undefined | null;
  loja: number[] | undefined | number;
  onChange(val: any, data: boolean): void;
  isRequired?: boolean;
  isDisabled?: boolean;
  setInvalid?: boolean;
}

/**
 * @param label Nome que será exibido na parte superior do componente
 * @function onChange Função que atualiza o valor do input
 * @returns Componente para validação de inputs
 */
const BuscaOperadoresLoja: React.FC<OperadoresProps> = (props) => {
  const { loja, onChange, value, isDisabled, setInvalid } = props;

  const [operadores, setOperadores] = useState<Options[]>([]);
  const [operadoresAtivos, setOperadoresAtivos] = useState<Options[]>([]);

  const { control, register, setValue } = useForm();

  useEffect(() => {
    (async () => {
      const { data } = await api.post(`/busca-operador`, { lojas: loja });

      if (data.success && data.data) {
        const options = data.data.map((operador: IOperadores) => ({
          label: operador.des_operador,
          value: operador.cod_operador,
        }));
        setOperadores(options);

        const optAtivos = data.data.flatMap((op: any) => {
          if (op.flg_inativo !== true) {
            return [
              {
                label: op.des_operador,
                value: op.cod_operador,
              },
            ];
          }
          return [];
        });

        setOperadoresAtivos(optAtivos);
      }
    })();
  }, [loja]);

  const handleChangeOperador = useCallback(
    (val: { label: string; value: number }, isInvalid: boolean) => {
      setValue('operador', val);
      onChange(val, isInvalid);
    },
    [onChange, setValue],
  );

  useEffect(() => {
    if (value) setValue('operador', value);
    else setValue('operador', { label: undefined, value: undefined });
  }, [setValue, value]);

  return (
    <Container>
      <div className="col-sm-12">
        <InputSelect
          placeholder={isDisabled ? 'Informe a Loja Primeiro' : 'Selecione'}
          options={operadoresAtivos as any[]}
          label="Operador"
          name="operador"
          control={control}
          register={register}
          isError={!!setInvalid}
          isDisabled={isDisabled}
          changeSelected={(newValue: any) => {
            handleChangeOperador(newValue, false);
          }}
        />
      </div>
    </Container>
  );
};

export default BuscaOperadoresLoja;
